<form [formGroup]="form" class="formgrid grid">
    <div class="field col-12">
        <label for="promoCustomerNumberInput">
            Kundennummer Bestandskunde
            <ow-validation-mark [control]="form.controls.promoCustomerNumber"></ow-validation-mark>
        </label>
        <input type="text" pInputText id="promoCustomerNumberInput" formControlName="promoCustomerNumber" class="w-full" />
        <p>
            Die Teilnahmebedingungen zur Aktion Kunde wirbt Kunde finden Sie <a href="https://www.swsls.de/kunde-wirbt-kunde.html" target="_blank">hier</a>.
        </p>
    </div>
</form>
